import { QueryKeys } from "@/constants";
import httpClient from "@/services";
import { useMutation } from "@tanstack/react-query";

export type IChangePasswordPayload = {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword?: string;
  username?: string;
  groupId?: string;
  divisionId?: string;
  memberId?: string;
  accessToken?: string;
};

export type IChangePasswordResponse = {
  summary: {
    status_message: string;
    member_id: string;
    status_code: string;
    query_id: string;
    group_id: string;
    query: string;
    query_time: number;
  };
  data: {
    message: string;
  };
};

export const changePasswordRequest = async (info: IChangePasswordPayload) => {
  const params = {
    currentPassword: info.currentPassword,
    newPassword: info.newPassword,
    username: info.username,
    groupId: info.groupId,
    divisionId: info.divisionId,
    memberId: info.memberId,
  } as IChangePasswordPayload;
  const config = {
    method: "POST",
    maxBodyLength: Infinity,
    url: "login/changePassword",
    headers: {
      Authorization: `Bearer ${info.accessToken}`,
      "Content-Type": "application/json",
      "Accept-Version": "3.0",
      Groupid: info.groupId,
    },
    data: params,
  };
  return httpClient.request(config).then((response) => response.data);
};

export const useMChangePassword = () => {
  return useMutation({
    mutationFn: (changePasswordResponse: IChangePasswordPayload) =>
      changePasswordRequest(changePasswordResponse),
    mutationKey: [QueryKeys.CHANGE_PASSWORD],
  });
};
